

export const initialValues = {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    password: '',
    role: '',
    signature: null,
};